import React from 'react';

export default function FilterChips({
  filterType,
  setFilterType,
  filterProvider,
  setFilterProvider,
  quickTypeChips,
  quickProviderChips,
  onResetAll,
}) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200/60 p-3 sm:p-4 shadow-card">
      <div className="flex flex-wrap gap-2 items-center">
        <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider mr-1">Type:</span>
        {quickTypeChips.map((type) => (
          <button
            key={type}
            onClick={() => setFilterType(type)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${
              filterType === type
                ? 'bg-brand-600 text-white border-brand-600 shadow-sm'
                : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50 hover:border-slate-300'
            }`}
          >
            {type}
          </button>
        ))}
        {quickTypeChips.length === 0 && (
          <span className="text-xs text-slate-400">No types yet</span>
        )}
      </div>
      <div className="flex flex-wrap gap-2 items-center mt-3">
        <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider mr-1">Provider:</span>
        {quickProviderChips.map((provider) => (
          <button
            key={provider}
            onClick={() => setFilterProvider(provider)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${
              filterProvider === provider
                ? 'bg-violet-600 text-white border-violet-600 shadow-sm'
                : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50 hover:border-slate-300'
            }`}
          >
            {provider}
          </button>
        ))}
        {quickProviderChips.length === 0 && (
          <span className="text-xs text-slate-400">No providers yet</span>
        )}
        <button
          onClick={onResetAll}
          className="w-full sm:w-auto sm:ml-auto px-3 py-1.5 rounded-xl text-xs font-medium border border-slate-200 text-slate-500 hover:bg-slate-50 hover:border-slate-300 transition-all"
        >
          Reset All
        </button>
      </div>
    </div>
  );
}
